import CityAPI from 'api/city';
import { initialState as destinationInitialState } from 'store/destination/destination-reducer';
import { Page } from 'utils/page-utils';
import SearchUtils from 'utils/search-utils';
import { v4 as uuidV4 } from 'uuid';
import appleInitialStateValidations from './apple-validations';
import UrlUtils from '@spothero/utils/url';
import { buildSearchInitialData, toSearchString } from './types';
export const getCityData = async ({ query: requestQuery }) => {
    const search = toSearchString(requestQuery);
    appleInitialStateValidations(search);
    const urlParams = UrlUtils.parseParams(search);
    const { kind, power_booking, pb_source, partner, operator_id, include_experimental_fields, filterSpot, monthly, starts, ends, eid, id, } = urlParams;
    if (Boolean(id) === false) {
        throw new Error('City ID is required');
    }
    const { data: city } = await CityAPI.get(id);
    const { data: { latitude, longitude, timezone }, } = city;
    // city searches have no destination - clear any stale destination data
    // left over in the store from a previously viewed destination/airport page
    const destination = destinationInitialState();
    const query = {
        kind,
        power_booking,
        pb_source,
        partner,
        operator_id,
        include_experimental_fields,
        filterSpot,
        monthly,
        starts,
        ends,
        eid,
    };
    const freshSearchRequest = {
        monthly: String(query.monthly) === 'true',
        airport: false,
        powerBooking: String(query.power_booking) === 'true',
        powerBookingSource: query.pb_source || null,
        latitude,
        longitude,
        id: uuidV4(),
        pageType: Page.CITY,
        filterSpot: query.filterSpot,
        partner: query.partner,
        operator_id: query.operator_id,
        include_experimental_fields: query.include_experimental_fields,
        ...SearchUtils.createTimeWindowParams(Page.CITY, {
            starts: query.starts ?? undefined,
            ends: query.ends ?? undefined,
            power_booking: query.power_booking ?? undefined,
        }, timezone),
    };
    return buildSearchInitialData({
        city,
        destination,
        searchType: Page.CITY,
        freshSearchRequest,
    });
};
